import { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import _ from 'lodash'
import { getParamQueryString, getQueryParamObject, getQuery, formatMultipleSelectArray } from '../helper/util'
import { constants } from '../Constants/constants'

export const useListParam = ({
  initialPath = '',
  initialListFilters = [],
  listTitles = [],
  initialSort = 'updateTimestamp',
  initialDirection = 'DESC',
  initialPage = 0,
  initialRowsPerPage = 10,
  changeUrlQueryString = false,
}) => {
  const history = useHistory()
  const location = useLocation()
  const filterParams = getQuery()

  const baseParam = {
    path: initialPath,
    page: initialPage,
    rowsPerPage: initialRowsPerPage,
    sort: initialSort,
    direction: initialDirection,
    listFilters: _.cloneDeep(initialListFilters),
    count: 0,
  }

  const [param, setParam] = useState(
    !changeUrlQueryString
      ? baseParam
      : getQueryParamObject(baseParam, _.cloneDeep(initialListFilters), listTitles)
  )

  useEffect(() => {
    if (!changeUrlQueryString) return

    const queryString = getParamQueryString(
      {
        path: initialPath,
        page: initialPage,
        rowsPerPage: initialRowsPerPage,
        sort: initialSort,
        direction: initialDirection,
        listFilters: _.cloneDeep(initialListFilters),
        count: param.count,
      },
      param
    )

    const currentQueryString = window.location.search?.substring(1)

    if (queryString === currentQueryString) return

    const newParam = getQueryParamObject(
      {
        path: initialPath,
        page: initialPage,
        rowsPerPage: initialRowsPerPage,
        sort: initialSort,
        direction: initialDirection,
        listFilters: _.cloneDeep(initialListFilters),
        count: param.count + 1,
      },
      _.cloneDeep(initialListFilters),
      listTitles
    )

    setParam(newParam)

    const newQuery = getParamQueryString(
      {
        path: initialPath,
        page: initialPage,
        rowsPerPage: initialRowsPerPage,
        sort: initialSort,
        direction: initialDirection,
        listFilters: _.cloneDeep(initialListFilters),
        count: 0,
      },
      newParam
    )

    history.replace({ pathname: location.pathname, search: newQuery })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterParams])

  const onChangeParam = (value) => {
    value.count = value.count + 1
    if (!changeUrlQueryString) {
      setParam(value)
      return
    }

    const queryString = getParamQueryString(
      {
        path: initialPath,
        page: initialPage,
        rowsPerPage: initialRowsPerPage,
        sort: initialSort,
        direction: initialDirection,
        listFilters: _.cloneDeep(initialListFilters),
        count: 0,
      },
      value
    )

    history.push({ pathname: location.pathname, search: queryString })
  }

  const onChangeListFilters = (list) => {
    const newList = list.map((item) => {
      // if (item.type === constants.TYPE.SELECT && item.multiple) {

      //   return {
      //     ...item,
      //     value: formatMultipleSelectArray(item.value, item.selectValue),
      //   }
      // }
      return item
    })

    let tempParam = _.cloneDeep(param)
    tempParam.listFilters = newList
    tempParam.page = 0
    onChangeParam(tempParam)
  }

  const onChangeListSort = (sortItem) => {
    let tempParam = _.cloneDeep(param)
    tempParam.sort = sortItem
    tempParam.direction = tempParam.direction === 'DESC' ? 'ASC' : 'DESC'
    onChangeParam(tempParam)
  }

  const onChangeListPage = (page) => {
    let tempParam = _.cloneDeep(param)
    tempParam.page = page
    onChangeParam(tempParam)
  }

  const onChangeListRowsPerPage = (rowsPerPage) => {
    let tempParam = _.cloneDeep(param)
    tempParam.page = 0
    tempParam.rowsPerPage = rowsPerPage
    onChangeParam(tempParam)
  }

  return {
    param,
    setParam,
    onChangeParam,
    onChangeListFilters,
    onChangeListSort,
    onChangeListPage,
    onChangeListRowsPerPage,
  }
}